export default __webpack_public_path__ + "static/media/devdao.527b09f1.svg";